import { Nav, NavItem } from 'react-bootstrap';
import styled from 'styled-components';

export const NavWrapper = styled(Nav)`
    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: white;
        color: black;
        // width: 160px;
        text-align: center;
        border: 1px solid #ddd;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: #337ab7;
        color: white;
    }

    & > li.active > a {
        font-size: 16px;
        line-height: 20px;
        background-color: #337ab7;
        color: white;
    }

    @media (max-width: 1823px) {
        & > li > a {
            font-size: 13px;
            line-height: 20px;
        }

        & > li.active > a {
            font-size: 14px;
            line-height: 20px;
        }
    }
`;

interface INavItemProps {
    tabWidth?: string
}

export const NavItemWrapper = styled(NavItem)<INavItemProps>`
    // & > a {
    //     width: ${(p: INavItemProps) => p.tabWidth ? p.tabWidth + 'px !important' : '150px'};
    // }

    // & > a {
    //     min-width: 140px;
    // }
`;